function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "@vaadin/combo-box/vaadin-combo-box.js";
import "../../common/toggle-group.js";
import { apiHost, FRIENDLY_ERROR_MESSAGE } from "../../lib/utils.js";
import axios from "axios";
import { css, html } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import "@vaadin/combo-box";
import "./pet-insurance-plan.js";
import { PackageToggleOfferElement } from "../../lib/package-toggle-offer-element.js";
import { SelectedState } from "../../lib/selected-state.js";
import { when } from "lit/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var PetInsurance = /*#__PURE__*/function (_PackageToggleOfferEl) {
  _inherits(PetInsurance, _PackageToggleOfferEl);

  var _super = _createSuper(PetInsurance);

  function PetInsurance() {
    var _this;

    _classCallCheck(this, PetInsurance);

    _this = _super.call(this);
    _this.annualLimit = 1e4;
    _this.deductibleAmount = 500;
    _this.breedSchema = void 0;
    _this.breedNotFound = false;
    _this.product = "pet-insurance";
    return _this;
  }

  _createClass(PetInsurance, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get("".concat(apiHost, "/v1/products/pet-insurance/breeds"), {
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-client-id": this.clientId,
                    "x-api-source": "Web Component",
                    "x-api-web-component-version": "4.4.1"
                  }
                });

              case 2:
                response = _context.sent;
                this.breedSchema = response.data;
                this.getDeclaredBreedId();

                _get(_getPrototypeOf(PetInsurance.prototype), "connectedCallback", this).call(this);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "getDeclaredBreedId",
    value: function getDeclaredBreedId() {
      var _this2 = this;

      var _a, _b, _c, _d;

      var foundBreedId = (_b = (_a = this.getBreedOptions()) == null ? void 0 : _a.find(function (b) {
        return b.name == _this2.declaredBreed;
      })) == null ? void 0 : _b.id;

      if (foundBreedId) {
        this.breedNotFound = false;
        this.breedId = foundBreedId;
      } else {
        this.breedNotFound = true;
        this.breedId = (_d = (_c = this.getBreedOptions()) == null ? void 0 : _c.find(function (b) {
          return b.name == _this2.getMiscellaneousBreedName();
        })) == null ? void 0 : _d.id;
      }
    }
  }, {
    key: "getBreedOptions",
    value: function getBreedOptions() {
      var _a, _b;

      if (this.species == "CAT") {
        return (_a = this.breedSchema) == null ? void 0 : _a.CAT;
      }

      return (_b = this.breedSchema) == null ? void 0 : _b.DOG;
    }
  }, {
    key: "getMiscellaneousBreedName",
    value: function getMiscellaneousBreedName() {
      if (this.species === "CAT") {
        return "Mixed Breed - Cat";
      }

      return "Rare Breed";
    }
  }, {
    key: "updateBreedSelection",
    value: function updateBreedSelection(e) {
      this.breedId = e.detail.value;
    }
  }, {
    key: "displayBreedSelection",
    value: function displayBreedSelection() {
      if (this.breedNotFound) {
        return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        <section id=\"breed-selection\">\n          <p>We couldn't quite find a match for the breed <strong>", "</strong>. Please select the proper breed in the dropdown list, or select <strong>", "</strong></p>\n          <vaadin-combo-box @value-changed=", " item-label-path=\"name\" item-value-path=\"id\" .items=", " .value=", ">\n        \n          </vaadin-combo-box>\n        </section>\n      "])), this.declaredBreed, this.getMiscellaneousBreedName(), this.updateBreedSelection, this.getBreedOptions(), this.breedId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _a;

      return (_a = this.productController) == null ? void 0 : _a.render({
        complete: function complete() {
          return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <div id=\"offer-display\">\n        <div id=\"offer-tag\">Recommended</div>\n        <div id=\"multi-offer-wrapper\">\n          ", "\n          <div id=\"offers\">\n            ", "\n          </div>\n          <div class=\"decline-action\">\n            <offer-accordion-header .showIcon=", " .showPromotionalHeader=", " @change=", " .checked=", ">\n              <h1>No, do not protect my pet.</h1>\n            </offer-accordion-header>\n          </div>\n          ", "\n          ", "\n          <section id=\"legal-disclaimer\">\n            <legal-disclaimer></legal-disclaimer>\n          </section>\n        </div>\n      </div>\n    "])), _this3.displayBreedSelection(), ["INJURY_ONLY", "INJURY_AND_ILLNESS"].map(function (plan, i) {
            return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n              <pet-insurance-plan \n                data-unique-id=", "\n                .clientId=", " \n                .customerFirstName=", " \n                .customerLastName=", "\n                .customerEmailAddress=", "\n                .customerCity=", "\n                .customerStreetAddress=", "\n                .customerPostalCode=", "\n                .customerState=", "\n                .age=", "\n                .plan=", "\n                .annualLimit=", "\n                .breedId=", "\n                .gender=", "\n                .petName=", "\n                .species=", "\n                .deductibleAmount=", "\n                @offer-state-change=", "\n              ></pet-insurance-plan>\n            "])), i, _this3.clientId, _this3.customerFirstName, _this3.customerLastName, _this3.customerEmailAddress, _this3.customerCity, _this3.customerStreetAddress, _this3.customerPostalCode, _this3.customerState, _this3.age, plan, _this3.annualLimit, _this3.breedId, _this3.gender, _this3.petName, _this3.species, _this3.deductibleAmount, _this3.offerStateChangeHandler);
          }), false, false, _this3.decline, _this3.selectedState === SelectedState.DECLINED, when(_this3.errors.length > 0 && _this3.errors.some(function (v) {
            return v in FRIENDLY_ERROR_MESSAGE;
          }), function () {
            return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <section id=\"errors\" class=\"error-message\">\n              ", "\n            </section>\n          "])), _this3.errors.map(function (e) {
              return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<p>", "</p>"])), FRIENDLY_ERROR_MESSAGE[e]);
            }));
          }), _this3.renderPaymentElement());
        }
      });
    }
  }]);

  return PetInsurance;
}(PackageToggleOfferElement);

PetInsurance.styles = [PackageToggleOfferElement.styles, css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      :host {\n        margin-top: 10px; \n      }\n\n      section#breed-selection {\n        margin:0;\n        margin-top: 10px;\n        margin-bottom: 10px;\n      }\n\n      section#breed-selection p {\n        margin-top: 0;\n        margin-bottom: 5px;\n      }\n\n      vaadin-combo-box {\n        width: 100%;\n        --vaadin-input-field-background: #ffffff;\n        --vaadin-input-field-value-font-size: 0.9rem;\n        --vaadin-input-field-value-color: #000000;\n        --vaadin-input-field-hover-highlight: #ffffff;\n        --vaadin-input-field-icon-color: #000000;\n      }\n\n      vaadin-combo-box::part(toggle-button) {\n        color: #000000;\n      }\n\n      vaadin-combo-box::part(input-field) {\n        //box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n        border: 1px solid var(--default-vi-border-color);\n        background-color: #ffffff;\n        border-radius: var(--default-vi-border-radius);\n        padding: 5px 10px;\n      }\n\n      vaadin-combo-box:hover, vaadin-combo-box[focused] {\n        background-color: transparent\n      }\n\n      vaadin-combo-box[focused]::part(input-field) {\n        border-color: black;\n      }\n\n      vaadin-combo-box::part(label), vaadin-combo-box[focused]::part(label) {\n        color: black;\n      }\n\n      #plan-type {\n        border: 1px solid var(--default-vi-border-color);\n        border-radius: var(--default-vi-border-radius);\n        padding: 6px 10px;\n        display: flex;\n        align-items: center;\n      }\n\n      #plan-type label {\n        display: block;\n        margin-right: 0.55rem;\n        font-size: 0.85rem;\n        white-space: nowrap;\n      }\n\n      #plan-type-menu {\n        position: relative;\n        width: 100%;\n      }\n\n      #plan-type-menu svg {\n        position: absolute; \n        right: 0.5rem;\n        top: 0.5rem;\n      }\n\n      select {\n        box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;\n        border: 1px solid rgb(226, 232, 240);\n        background-color: #ffffff;\n        border-radius: var(--default-vi-border-radius);\n        cursor: pointer;\n        appearance: none;\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        padding-left: 0.75rem;\n        padding-right: 2rem;\n        width: 100%;\n      }\n\n      @container (max-width: 700px) {\n        #plan-type { \n          align-items: flex-start;\n          padding: 0;\n          border: none;\n          margin: 0 0 10px 0;\n        }\n\n        #plan-type label {\n          margin-right: 0;\n          margin-bottom: 0.45rem;\n        }\n      }\n\n      @media (max-width: 700px) {\n        #plan-type { \n          align-items: flex-start;\n          padding: 0;\n          border: none;\n          margin: 0 0 10px 0;\n        }\n\n        #plan-type label {\n          margin-right: 0;\n          margin-bottom: 0.45rem;\n        }\n      }\n    "])))];

__decorateClass([property({
  attribute: "species"
})], PetInsurance.prototype, "species", 2);

__decorateClass([property({
  attribute: "declared-breed"
})], PetInsurance.prototype, "declaredBreed", 2);

__decorateClass([property({
  attribute: "pet-name"
})], PetInsurance.prototype, "petName", 2);

__decorateClass([property({
  type: Number,
  attribute: "age"
})], PetInsurance.prototype, "age", 2);

__decorateClass([property({
  attribute: "gender"
})], PetInsurance.prototype, "gender", 2);

__decorateClass([property({
  type: Number,
  attribute: "annual-limit"
})], PetInsurance.prototype, "annualLimit", 2);

__decorateClass([property({
  type: Number,
  attribute: "deductible-amount"
})], PetInsurance.prototype, "deductibleAmount", 2);

__decorateClass([state()], PetInsurance.prototype, "breedSchema", 2);

__decorateClass([state()], PetInsurance.prototype, "breedId", 2);

__decorateClass([state()], PetInsurance.prototype, "breedNotFound", 2);

PetInsurance = __decorateClass([customElement("pet-insurance")], PetInsurance);
export { PetInsurance };